$.fn.validateInput = function () {
    $(this).removeClass("state--invalid state--valid");
    if ($(this).find("input, textarea").val() !== "") {
        if ($(this).find("input, textarea").is(":valid")) {
            $(this).addClass("state--valid");
        } else {
            $(this).addClass("state--invalid");
        }
    }
};